export const pad2 = (n) => String(n).padStart(2, "0");

export const ymdLocal = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const startOfLocalDay = (ymd) => {
  const parts = String(ymd || "").split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return null;
  const [year, month, day] = parts;
  return new Date(year, month - 1, day, 0, 0, 0, 0);
};

export const endOfLocalDay = (ymd) => {
  const parts = String(ymd || "").split("-").map(Number);
  if (parts.length !== 3 || parts.some((n) => !Number.isFinite(n))) return null;
  const [year, month, day] = parts;
  return new Date(year, month - 1, day, 23, 59, 59, 999);
};

export const presetYmdRange = (days) => {
  if (days === "all" || days === "custom") return { from: "", to: "" };
  const n = Number(days);
  const span = Number.isFinite(n) && n > 0 ? Math.floor(n) : 30;
  const to = new Date();
  const from = new Date(to.getFullYear(), to.getMonth(), to.getDate());
  from.setDate(from.getDate() - (span - 1));
  return { from: ymdLocal(from), to: ymdLocal(to) };
};

export const rangeQueryParams = ({ days = 30, fromDate = "", toDate = "" } = {}) => {
  const params = {};
  const from = fromDate ? startOfLocalDay(fromDate) : null;
  const to = toDate ? endOfLocalDay(toDate) : null;
  if (from) params.from = from.toISOString();
  if (to) params.to = to.toISOString();
  if (!params.from && !params.to) {
    params.days = days === "all" || days === "custom" ? "all" : days;
  }
  return params;
};
